import { render, staticRenderFns } from "./ClientDocumentationCard.vue?vue&type=template&id=2643c640&"
import script from "./ClientDocumentationCard.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports